const promoRewardModalBinds = () => {
	$('#dynamicModalContainer').on('shown.bs.modal', function (e) {
		$("div[class*='modal-PickYourFreeGift'] .pwp-qty-minus").parent('td').attr('width', '150');
	});

	$('.pwp-qty-minus, .pwp-qty-plus').on('selectstart', function (e) {
		e.preventDefault();
	});

	$('.pwp-qty-minus').on('click', function (e) {
		if (e.target.id.indexOf('-') != -1) minusQtyAction(e.target.id.split('-')[1]);
	});

	$('.pwp-qty-plus').on('click', function (e) {
		if (e.target.id.indexOf('-') != -1) plusQtyAction(e.target.id.split('-')[1]);
	});

	$('input[name=quantity]').on('input blur', function (e) {
		if (e.target.id.indexOf('-') != -1) validateInput(e.target.id.split('-')[1], e.target.value, e.type);
	});

	$('#resetOffer').on('click', function (e) {
		resetSelections(e.target.dataset.state);
	});

	$('.pwpA2B').on('click', function (e) {
		if (e.target.id.indexOf('-') != -1) validateSelectionAndA2B(e.target.id.split('_')[1]);
	});

	$('input[name=decline_gift]').on('click', function (e) {
		handleDeclineEvent(e.target.checked);
	});
};

const minusQtyAction = (productRow) => {
	var currentQty = $('#pwpQtyInput-' + productRow).val();
	if(currentQty > 0 && ($('input[name=decline_gift]')[0] === undefined || ($('input[name=decline_gift]')[0] !== undefined && !$($('input[name=decline_gift]')[0])[0].checked))){
		$('#pwpQtyInput-' + productRow).val(parseInt(currentQty) - 1);
		$('#pwpQtyInput-' + productRow).data('orgval', parseInt(currentQty) - 1);
		$('.pwpA2B').removeClass('disabled');

		if ($('#pwpQtyInput-' + productRow).val() == 0 && $('.pwpA2B').attr('id').split('_')[2] == 0 && getSummedQty() == 0) $('.pwpA2B').addClass('disabled');
	}else {
		return false;
	}
};

const plusQtyAction = (productRow) => {
	var currentQty = $('#pwpQtyInput-' + productRow).val(),
		maxItemQty = $('#pwpQtyInput-' + productRow).data('maximum'),
		maxRewardQty = $('#pwpQtyInput-' + productRow)
			.closest('table')
			.find('input[name=rewardMaxQty]')
			.val();

	if(currentQty < maxItemQty && (getSummedQty() < maxRewardQty || maxRewardQty == 99) && ($('input[name=decline_gift]')[0] === undefined || ($('input[name=decline_gift]')[0] !== undefined && !$($('input[name=decline_gift]')[0])[0].checked))) {
		$('#pwpQtyInput-' + productRow).val(parseInt(currentQty) + 1);
		$('#pwpQtyInput-' + productRow).data('orgval', parseInt(currentQty) + 1);
		$('.pwpA2B').removeClass('disabled');
	}else {
		return false;
	}
};

const validateInput = (productRow, newVal, type) => {
	var selector = $('#pwpQtyInput-' + productRow);
	var originalValue = $(selector).data('orgval') > 0 ? $(selector).data('orgval') : 0;

	if (type === 'input') {
		var newValNumeric = newVal.replace(/[^0-9]/g, ''),
			maxItemQty = $(selector).data('maximum'),
			maxRewardQty = $(selector).closest('table').find('input[name=rewardMaxQty]').val();

		if (newVal.length > newValNumeric.length || parseInt(newValNumeric) > maxItemQty || (getSummedQty() > maxRewardQty && maxRewardQty != 99)) {
			$(selector).val(originalValue);
		} else {
			if (newVal != '') $(selector).data('orgval', newVal);
		}
	}
	if (type === 'blur') {
		var parVal = parseInt(newVal, 10);
		if (newVal.length == 0) {
			$(selector).val(0);
		} else {
			$(selector).val(parVal);
			$(selector).data('orgval', parVal);
			if ($('#resetOffer').data('state') == 0 && getSummedQty() == 0) $('.pwpA2B').addClass('disabled');
			if ($('#resetOffer').data('state') == 0 && getSummedQty() > 0) $('.pwpA2B').removeClass('disabled');
		}
	}
};

const resetSelections = (state) => {
	var inputs = $('input[name=quantity]');
	$.each(inputs, function () {
		this.value = 0;
		$(this).data('orgval', 0);
	});
	if (parseInt(state) > 0) $('.pwpA2B').removeClass('disabled');
	if (parseInt(state) == 0) $('.pwpA2B').addClass('disabled');
};

const getSummedQty = () => {
	var allQtyInputs = $('.giftHeader').closest('table').find('input[name=quantity]'),
		summedQty = 0;

	$.each(allQtyInputs, function () {
		summedQty = parseInt(summedQty) + parseInt(this.value);
	});

	return summedQty;
};

const validateSelectionAndA2B = (rewardId) => {
	var valid = true,
		form = $('#updateRewardSelections_' + rewardId),
		formData = [];

	if (getSummedQty() > $('.giftHeader').closest('table').find('input[name=rewardMaxQty]').val()) valid = false;

	var allQtyInputs = $('.giftHeader').closest('table').find('input[name=quantity]');
	$.each(allQtyInputs, function () {
		if (this.value > this.dataset.maximum) valid = false;
		if ((this.value > 0 || ($('input[name=decline_gift]')[0] !== undefined && $($('input[name=decline_gift]')[0])[0].checked)) && valid) {
			var giftRow = this.id.split('-')[1];
			formData.push(
				$('.giftrow_' + giftRow)
					.find('input[name=catalogEntryID]')
					.val() +
				'_' +
				this.value +
				'_' +
				$('.giftrow_' + giftRow)
					.find('input[name=prodDescription]')
					.val()
			);
		}
	});

	if (valid) {
		$.each(formData, function (i, productData) {
			var split = productData.split('_');

			var input1 = $('<input/>');
			input1.attr('type', 'hidden');
			input1.attr('name', 'catEntryId_' + i);
			input1.attr('value', split[0]);
			form.append(input1);
			var input2 = $('<input/>');
			input2.attr('type', 'hidden');
			input2.attr('name', 'quantity_' + i);
			input2.attr('value', split[1]);
			form.append(input2);
			var input3 = $('<input/>');
			input3.attr('type', 'hidden');
			input3.attr('name', 'description_' + i);
			input3.attr('value', split[2]);
			form.append(input3);
		});

		if($('input[name=decline_gift]')[0] !== undefined){

			var input = $('<input/>');
			input.attr('type', 'hidden');
			input.attr('name', 'declineGift');
			input.attr('value', $($('input[name=decline_gift]')[0])[0].checked);
			form.append(input);
		}

		form.submit();
	}
};

const handleDeclineEvent = (isDeclined) => {
	$.each($($("[id^=giftTable_]")[0]).find("input[name=quantity]"), function(){
		if(isDeclined){
			$(this).val(0);
			$(this).attr('disabled', 'true')
			$(this).css({"color":"#cccccc"})
			$('.pwpA2B').removeClass('disabled');
		}else{
			$(this).attr('disabled', '')
			$(this).css({"color":"#000"})
		}
	});
}

export { promoRewardModalBinds };
